import { ReactNode } from 'react'
import { connect } from 'react-redux'

import BasePage, { CONNECTION_ERROR } from '../BasePage'

import { STEP_2_VALIDATION_URL } from '../../costants'

import Contractor from '../../components/people/contractor/Contractor'
import SiNo, { SiNoType, getBoolean, getSiNoValue } from '../../components/siNo/SiNo'
import { isValidPrivacy, getPrivacyForSubmit } from '../../components/privacy/BasicPrivacy'

import LoginRegister from '../../components/login/LoginRegister'
import CommonsPolicyFields from '../../components/commons/CommonsPolicyFields'
import NoMotorPrivacy from '../../components/privacy/NoMotorPrivacy'
import ModalFinalQuestion from '../../components/final/ModalFinalQuestion'

import SinglePage from '../../components/pagination/SinglePage'
import Pagination from '../../components/pagination/Pagination'

import { authFetch } from '../../libs/cookie/Cookie'

import Input from '../../libs/ui/inputs/Input'
import Select from '../../libs/ui/inputs/Select'
import ModalWaith from '../../libs/ui/modal/ModalWaith'
import ModalNotification from '../../libs/ui/modal/ModalNotification'

import * as StringValidation from '../../libs/validation/stringRegex'
import { isNotValidScadenzaPolizza } from '../../libs/validation/dateValidation'
import { objectsNamesValidation } from '../../libs/validation/remoteValidationAbstract'
import { CompleteValidationError } from '../../libs/validation/completeValidationError'

import { getTipiAnimaili } from '../../libs/initialization/remoteInits'

import { PetPageProps, PetPageState, petPageInitialState, petsUpdate } from './PetPageSilce'

import { ZUKO_TRAK_ID } from '../../trak/zuko'

import { store } from '../../redux/store'

import '../../sass/App.scss'

class PetPage extends BasePage<PetPageProps, PetPageState> {
    constructor (props: any) {
        super(props)

        this.state = {
            ...petPageInitialState,
            ...props
        }

        // metodi ereditati
        this.getInitialState = this.getInitialState.bind(this)
        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)
        this.getRilevanzaForSubmit = this.getRilevanzaForSubmit.bind(this)
        this.getSpecificDataForSubmit = this.getSpecificDataForSubmit.bind(this)
        this.saveStateAndRedux = this.saveStateAndRedux.bind(this)

        // metodi specifici del preventivatore
        this.updateTipo_animali = this.updateTipo_animali.bind(this)
        this.updateNome = this.updateNome.bind(this)
        this.updateRazza = this.updateRazza.bind(this)
        this.updateChip = this.updateChip.bind(this)

        this.updateTipiAnimali = this.updateTipiAnimali.bind(this)

        this.step2Validation = this.step2Validation.bind(this)
    }

    componentDidMount(): void {
        super.componentDidMount()
        
        const Zuko = window.Zuko

        if (Zuko && ZUKO_TRAK_ID) {
            Zuko.trackForm( {target: document.body, slug: ZUKO_TRAK_ID} ).trackEvent(Zuko.FORM_VIEW_EVENT)
        }

        if (this.state.tipi === undefined) {
            getTipiAnimaili (this.updateTipiAnimali, this.manageExpiredSessions)
        }
    }

    render () : ReactNode  {
        const isLogged = this.state.expiredSessionError === false ? this.state.user !== undefined : false

        const erroOccours = this.state.globalError !== undefined

        return (
            <>
                <article className='container-fluid py-5'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-8'>

                            <header className='row'>
                                <form id="login_register_form" autoComplete='off'>
                                    <LoginRegister 
                                        isLogged={ isLogged } 
                                        isExpire={ this.state.expiredSessionError }
                                        showTitle={ true }
                                        loggedOkCallBack={ this.logUser }
                                        expiredSessionCallbak={ this.manageExpiredSessions }
                                    />
                                </form>
                            </header>

                            <form id="pets_form">
                                <Pagination
                                    maxPagges={2}
                                    actualPage={this.state.actualPage}
                                    updateActualPageCallBack={this.updateActualPage}
                                    manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                >
                                    <SinglePage
                                        show={this.state.actualPage === 1}
                                        pageNumber={1}
                                        isLast={false}
                                        validatePage={this.step1Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <Contractor 
                                            people={this.state.contractor}
                                            updatePeopleCallback={this.updateContractor}
                                            user={this.state.user}
                                            updateUserCallBack={ this.updateUser }
                                            expiredSessionCallbak={ this.manageExpiredSessions }
                                            error={this.state.contractorError}
                                            isOnlyFisica={false}
                                            isOnlyGiuridica={false}
                                        />
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 2}
                                        pageNumber={2}
                                        isLast={true}
                                        validatePage={this.step2Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                        sendCallBack={this.sendData}
                                    >
                                        <CommonsPolicyFields 
                                            rilevanza={ this.state.rilevanza }
                                            rilevanzaErrro={ this.state.rilevanzaError }
                                            updateRilevanza={ this.updateRilevanza }

                                            altriSinistri={this.state.altriSinistri}
                                            altriSinistriError={this.state.altriSinistriError}
                                            polizzaAttiva={this.state.polizzaAttiva}
                                            polizzaAttivaError={this.state.polizzaAttivaError}
                                            scadenzaPolizza={this.state.scadenzaPolizza}
                                            scadenzaPolizzaError={this.state.scadenzaPolizzaError}

                                            updateAltriSinistri={this.updateAltriSinistri}
                                            updatePloizzaAttiva={this.updatePloizzaAttiva}
                                            updateScadenzaPolizza={this.updateScadenzaPolizza}
                                        />

                                        <div className='col-12'>
                                            <Select
                                                id='tipo_animali' name='tipo_animali' key='tipo_animali'
                                                label='Indica il tuo animale' 
                                                value={this.state.tipo_animali}
                                                options={this.state.tipi}
                                                callback={this.updateTipo_animali}
                                                error={this.state.tipo_animaliError}
                                            />

                                            <Input 
                                                id='nome' name='nome' key='nome'
                                                label='Nome dell’animale' 
                                                value={this.state.nome}
                                                type='text'
                                                maxLength={65}
                                                callback={this.updateNome}
                                                regexp={StringValidation.OBJECTS_NAMES_PATTERN}
                                                errorDisplayMsg='Valore non valido'
                                                remoteValidation={objectsNamesValidation}
                                                error={this.state.nomeError}
                                            />

                                            <Input 
                                                id='razza' name='razza' key='razza'
                                                label='Razza dell’animale' 
                                                value={this.state.razza}
                                                type='text'
                                                maxLength={100}
                                                callback={this.updateRazza}
                                                regexp={StringValidation.OBJECTS_NAMES_PATTERN}
                                                errorDisplayMsg='Valore non valido'
                                                remoteValidation={objectsNamesValidation}
                                                error={this.state.razzaError}
                                            />

                                            <SiNo 
                                                id='chip' name="chip" key='chip'
                                                label='Ha un microchip?'
                                                value={ getSiNoValue( this.state.chip ) }
                                                callback={this.updateChip}
                                                error={this.state.chipError}
                                            />
                                        </div>

                                        <NoMotorPrivacy 
                                            id='noMotorPrivacy'
                                            basePrivacy={this.state.noMotorPrivacy}
                                            isLogged={this.state.user !== undefined}
                                            callback={this.updateNoMotorPrivacy}
                                            error={this.state.noMotorPrivacyError}
                                        />
                                    </SinglePage>

                                </Pagination>
                            </form>
                        </div>
                    </div>

                    <ModalWaith isOpen={this.state.waith}/>

                    <ModalNotification
                        title='Si è verificato un problema'
                        isError={erroOccours}
                        isOpen={erroOccours}
                        callBackToggle={ () => this.setState ({globalError: undefined}) }
                    >
                        {this.state.globalError}
                    </ModalNotification>

                    <ModalFinalQuestion 
                        isOpen={this.state.finalQuestIsOpen}
                        quoteRequestId={this.state.quoteRequestId}
                        callBackToggle={this.closeFinalQuestion}
                        expiredSessionCallbak={this.manageExpiredSessions}
                    />
                </article>
            </>
        )
    }

    // -- comuni
    getInitialState() {
        return petPageInitialState
    }
    
    getSpecificDataForSubmit () {
        return {
            sinistriPrecedenti: this.state.altriSinistri ?? false,
            polizzaGiaAttiva: this.state.polizzaAttiva ?? false,
            dataScadenza: (this.state.polizzaAttiva === true) 
                ? (this.state.scadenzaPolizza ?? null)
                : null,

            rilevanza: this.getRilevanzaForSubmit(),

            tipo_animali: this.state.tipo_animali !== undefined ? this.state.tipo_animali : null, 
            nome: this.state.nome !== undefined ? this.state.nome : null, 
            razza: this.state.razza !== undefined ? this.state.razza : null, 
            microchip: this.state.chip !== undefined ? this.state.chip : null, 
        }
    }

    getValidationError () : Promise<CompleteValidationError> {
        return Promise.all([
            this.step1Validation(),
            this.step2Validation(),
        ])
        .then ((responses) => {
            let p: number | undefined = undefined
            let e: string | undefined  = undefined

            if (responses[0] !== undefined) {
                p = 1
                e = responses[0]
            }
            else if (responses[1] !== undefined) {
                p = 2
                e = responses[1]
            }

            return {
                errorString: e,
                pageError: p
            }
        })
        .catch (() => {
            return {
                errorString: CONNECTION_ERROR,
                pageError: undefined
            }
        })
    }
    printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) {
        const superErrors = super.printError(errorString, waith, pageError)

        if (superErrors?.globalError !== undefined) {
            this.setState( superErrors )
        }
        else {
            let tipo_animaliErro = undefined
            let nomeErro = undefined
            let razzaErro = undefined
            let chipErro = undefined
            let noMotorPrivacyErro = undefined

            let global = undefined

            if (errorString === 'TIPO_ANIMALI' ) {
                tipo_animaliErro = 'Valore non valido'
                global = 'Indicare il tipo di animale posseduto'
            }
            else if (errorString === 'NOME' ) {
                nomeErro = 'Valore non valido'
                global = 'Inicare il nome del animale'
            }
            else if (errorString === 'RAZZA' ) {
                razzaErro = 'Valore non valido'
                global = 'Inicare la razza del animale'
            }
            else if (errorString === 'MICROCHIP' ) {
                chipErro = 'Valore non valido'
                global = "Inicare se l'animale ha il microchip"
            }
            else if ( errorString === 'PRIVACY' ) {
                noMotorPrivacyErro = 'Selezionare i campi obbligatori'
                global = noMotorPrivacyErro
            } 
            else {
                global = errorString
            }

            this.setState ({
                waith: waith,
                actualPage: pageError ?? this.state.actualPage,

                tipo_animaliError: tipo_animaliErro,
                nomeError: nomeErro,
                razzaError: razzaErro,
                chipError: chipErro,
                
                noMotorPrivacyError: noMotorPrivacyErro,
                globalError: global,
            })
        }
    }

    saveStateAndRedux (newState : object) {
        this.setState(
            newState, () => {
                store.dispatch (
                    petsUpdate (this.state)
                )
            }
        )
    }

    // -- solo del preventivatore
    private updateTipiAnimali (tipi: any) {
        this.setState ({
            tipi: tipi
        })
    }
    private updateTipo_animali (val: string | undefined) {
        this.saveStateAndRedux ({
            tipo_animali: val,
            tipo_animaliError: undefined,
        })
    }
    private updateNome (val: string | undefined) {
        this.saveStateAndRedux ({
            nome : val,
            nomeError: undefined
        })
    }
    private updateRazza (val: string | undefined) {
        this.saveStateAndRedux ({
            razza : val,
            razzaError: undefined
        })
    }
    private updateChip (val: SiNoType) {
        this.saveStateAndRedux ({
            chip : getBoolean( val ),
            chipError: undefined
        })
    }

    private async step2Validation () {
        let error = undefined

        if (this.state.altriSinistri === undefined) {
            error = 'SINISTRI'
        }
        else if (this.state.polizzaAttiva === undefined) {
            error = 'POLIZZA'
        }
        else if (
            this.state.polizzaAttiva === true && 
            isNotValidScadenzaPolizza(this.state.scadenzaPolizza)
        ) {
            error = 'SCADENZA_POLIZZA'
        }

        else if ( this.state.tipo_animali === undefined ) {
            error = 'TIPO_ANIMALI'
        }
        else if ( this.state.nome === undefined || this.state.nome.length < 2 || this.state.nome.length > 100) {
            error = 'NOME'
        }
        else if ( this.state.razza === undefined || this.state.razza.length < 2 || this.state.razza.length > 100) {
            error = 'RAZZA'
        }
        else if ( this.state.chip === undefined ) {
            error = 'MICROCHIP'
        }

        // comuni
        else if (!isValidPrivacy(this.state.noMotorPrivacy, this.state.user !== undefined)) {
            error = 'PRIVACY'
        }

        else {
            await authFetch (
                STEP_2_VALIDATION_URL,
                {
                    method: "post",
                    body: JSON.stringify({
                        specificData: this.getSpecificDataForSubmit(),
                        privacy: getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user),
                        isLogged: this.state.expiredSessionError === false ? this.state.user !== undefined : false
                    })
                },
                this.manageExpiredSessions,
            ).then ( jsonObj => {
                if (jsonObj.status > 200) {
                    error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
                }
            }).catch( error => {
                error = CONNECTION_ERROR
            })
        }

        this.printError(error)

        return error
    }
}

const mapState = (state: any) => {
  return {
    contractor: state.contractor,
    altriSinistri: state.altriSinistri,
    polizzaAttiva: state.polizzaAttiva,
    scadenzaPolizza: state.scadenzaPolizza,
    rilevanza: state.rilevanza,

    tipo_animali: state.tipo_animali,
    nome: state.nome,
    razza: state.razza,
    chip: state.chip,

    actualPage: state.actualPage,

    noMotorPrivacy: state.noMotorPrivacy,
    user: state.user
  }
}

export default connect(mapState) (PetPage)